import { MatDialog } from '@angular/material/dialog';
import { DownloadAssetsService } from '@thehubz/client/asset-services';
import { AssetUIModel, ViewType } from '@thehubz/client/core';
import { AnyType } from '@thehubz/shared/model';
import { AssetRelationsService } from '../components/asset-detail-view/asset-relations/asset-relations.service';
import { AssetDownloadComponent, AssetDownloadData } from '../components/asset-download/asset-download.component';
import { AssetCommonService } from '../services/asset-common.service';
import { AssetViewTypeService } from '../services/asset-view-type.service';

/**
 * Base class for assets viewer components.
 */
export class AssetsViewerBase {
  itemSize = 310;
  currentSize: AnyType;
  imageObject: AssetUIModel[] = [];
  /**
   * This 2d array is created for use with the cdkVirtualScroll
   */
  imageSplitObject!: AssetUIModel[][];
  selectedViewType!: ViewType;
  size = 4;
  gridConfig: AnyType = {
    showListView: false,
    showGridView: true,
    showGridViewSmall: true,
    showGridViewLarge: false,
    showGridViewSidebar: false,
  };
  gridSettingsKeySuffix = 'RelationsTab';

  constructor(
    protected assetCommonService: AssetCommonService,
    protected downloadAssetsService: DownloadAssetsService,
    protected dialog: MatDialog,
    protected assetRelationsService: AssetRelationsService,
    protected assetViewTypeService: AssetViewTypeService,
  ) {}

  changeAssetView(view: AnyType) {
    this.assetRelationsService._selectedViewType.next(view);
    if (view !== 'list') {
      this.gridConfig.showListView = false;
      this.gridConfig.showGridView = true;
      this.assetViewTypeService.setGridConfig(this.gridSettingsKeySuffix, this.gridConfig);
      if (view === 'grid_3') {
        this.gridConfig.showGridViewSmall = false;
        this.gridConfig.showGridViewLarge = false;
        this.gridConfig.showGridViewSidebar = true;
        this.gridConfig.gridSize = 3;
        this.selectedViewType = 'grid_3';
        this.assetViewTypeService.setGridConfig(this.gridSettingsKeySuffix, this.gridConfig);
        this.size = 3;
      }
      if (view === 'grid_4') {
        this.gridConfig.showGridViewSmall = true;
        this.gridConfig.showGridViewLarge = false;
        this.gridConfig.gridSize = 4;
        this.selectedViewType = 'grid_4';
        this.assetViewTypeService.setGridConfig(this.gridSettingsKeySuffix, this.gridConfig);
        this.size = 4;
      }
      if (view === 'grid_6') {
        this.gridConfig.showGridViewSmall = false;
        this.gridConfig.showGridViewLarge = false;
        this.gridConfig.showGridViewSidebar = true;
        this.gridConfig.gridSize = 6;
        this.selectedViewType = 'grid_6';
        this.assetViewTypeService.setGridConfig(this.gridSettingsKeySuffix, this.gridConfig);
        this.size = 6;
      }
      if (view === 'grid_8') {
        this.gridConfig.showGridViewSmall = false;
        this.gridConfig.showGridViewLarge = true;
        this.gridConfig.gridSize = 8;
        this.selectedViewType = 'grid_8';
        this.assetViewTypeService.setGridConfig(this.gridSettingsKeySuffix, this.gridConfig);
        this.size = 8;
        this.itemSize = 155;
      }
      this.setAssetView(this.currentSize);
      this.imageSplitObject = [];
      this.imageSplitObject = this.split(this.imageObject, this.size);
    }
    if (view === 'list') {
      this.gridConfig.showGridView = false;
      this.gridConfig.showGridViewSmall = false;
      this.gridConfig.showGridViewLarge = false;
      this.gridConfig.showListView = true;
      this.selectedViewType = 'list';
      this.assetViewTypeService.setGridConfig(this.gridSettingsKeySuffix, this.gridConfig);
    }
  }

  private split(input: AssetUIModel[], groupSize: number): AssetUIModel[][] {
    const out = [];
    for (let i = 0; i < input.length; i += groupSize) {
      out.push(input.slice(i, i + groupSize));
    }
    return out;
  }

  setAssetView(currentSize?: AnyType) {
    const gridSettings = this.assetViewTypeService.getGridConfig(this.gridSettingsKeySuffix);
    if (gridSettings.showGridViewLarge) {
      this.size = 8;
      if (currentSize?.name === 'xl') this.size = 4;
      if (currentSize?.name === 'lg') this.size = 3;
      if (currentSize?.name === 'md') this.size = 2;
    }
    if (gridSettings.showGridViewSmall) {
      this.size = 4;
      if (currentSize?.name === 'lg') this.size = 3;
      if (currentSize?.name === 'md') this.size = 2;
    }
  }

  download(asset: AssetUIModel) {
    const downloadData = this.downloadAssetsService.createDownloadData([asset]);
    this.dialog.open<AssetDownloadComponent, AssetDownloadData>(AssetDownloadComponent, { width: '60%', disableClose: true, data: { data: downloadData } });
  }
}
